import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import { serviceBundleApiKeyStore } from '../../../../api/service-bundle-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import CloseIcon from '@mui/icons-material/Close';

import { useLoadData } from '../../../../hooks/useLoadData';
import { Service } from '../../../../models/masters/service';
import { ApiResponse } from '../../../../models/api-response';
import { useEffect, useState } from 'react';
import { LoadingIndicator } from '../../../../components/loading-indicator.component';

interface ServiceListGroup {
  serviceGroupID: number;
  serviceGroupName: string;

  services: Service[];
}
interface ServiceListDraggableProps {
  services: ServiceListGroup[];
}

type GroupedServices = {
  [key: string]: Service[]; // Index signature for numerical keys
};

interface ServicesDetailsProps {
  splitID: number;
  onClose: () => void;
  open: boolean;
}
export const ServicesDetails = ({ splitID, onClose, open }: ServicesDetailsProps) => {
  const { data, isLoading } = useLoadData<ApiResponse<Service[]>>(serviceBundleApiKeyStore.getSplitItem(splitID));
  const [groupServicesList, setGroupServicesList] = useState<GroupedServices>();
  const handleClosed = () => {
    onClose();
  };

  const groupServices = (services: Service[]): GroupedServices => {
    return services.reduce((acc, service) => {
      const { serviceGroupName } = service;

      if (!acc[serviceGroupName]) {
        acc[serviceGroupName] = []; // Initialize array if not already present
      }

      acc[serviceGroupName].push(service); // Add service to the correct group
      return acc;
    }, {} as GroupedServices);
  };

  useEffect(() => {
    if (data?.data) {
      const groupedService = groupServices(data?.data);
      setGroupServicesList(groupedService);
    }
  }, [data?.data]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={handleClosed}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" sx={{ p: 1, m: 1 }}>
        Service Details
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        {/* <SiTrackGrid
          columns={columns}
          dataItemKey="serviceID"
          queryConfig={serviceBundleApiKeyStore.getSplitItem(splitID)}
        /> */}
        <div className="slplitBlock bundlePopupMaxHeight">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <strong style={{ width: '50%' }}>Services</strong>
            <strong style={{ width: '50%' }}>Predecessor</strong>
            <strong style={{ width: '20%' }}>Accrual Amount</strong>
          </div>
        </div>
        {isLoading && <LoadingIndicator isLoading={isLoading} />}
        {!!groupServicesList && (
          <div style={{ padding: '15px', margin: '20px 0' }}>
            {Object.entries(groupServicesList)?.map(([groupName, services], index) => {
              return (
                <div key={groupName}>
                  <Typography variant="h6">{groupName}</Typography>
                  <List>
                    {services?.map((service: Service, index: any) => (
                      <ListItem key={service.serviceID} style={{ background: '#f1f1f1' }}>
                        <ListItemText
                          primary={
                            <Grid
                              container
                              spacing={2}
                              justifyContent="space-between"
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                backgroundColor: '#f2f3f',
                              }}
                            >
                              <Grid item>{service.serviceName}</Grid>
                              <Grid item>{service.predecessorNames}</Grid>
                              <Grid item> {service?.accrualAmount !== 0 ? `$${service?.accrualAmount}` : ''}</Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                  <Divider />
                </div>
              );
            })}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
